<template>
    <div class="terapi">
      <!-- 顶部介绍部分 -->
      <el-row class="intro-section">
        <h2>Behandlingsprocedur i korthet</h2>
        <ul>
          <li>Förklaring av behandlingsmetoder för patienter.</li>
          <li>Individuell diagnos baserad på traditionell kinesisk medicin.</li>
          <li>Behandlingsplan inklusive akupunktur, moxibustion, massage, koppning etc.</li>
        </ul>
        <el-button type="success" class="book-btn" @click="toLink">BOKA TID</el-button>
      </el-row>
  
      <!-- 治疗内容 -->
      <div class="treatment-section">
        <h3>Klinic ger behandlingar enligt följande:</h3>
  
        <el-row
          v-for="(item, index) in treatments"
          :key="index"
          :gutter="20"
          class="treatment-item"
        >
          <el-col :span="10" :order="index % 2 === 0 ? 1 : 2">
            <el-image :src="item.image" class="treatment-img" fit="cover"></el-image>
          </el-col>
          <el-col :span="14" :order="index % 2 === 0 ? 2 : 1">
            <h4>{{ item.title }}</h4>
            <p>{{ item.description }}</p>
          </el-col>
        </el-row>
      </div>
  
      <!-- 结尾按钮 -->
      <el-row class="footer-section" :span="24">
        <el-button type="success" class="help-btn" @click="toKontakt">Går du behov hjälp?</el-button>
      </el-row>
    </div>
  </template>
  
  <script>
  export default {
    name: "TerapiPage",
    data() {
      return {
        treatments: [
          {
            title: "1. Akupunktur",
            description:
              "Akupunktur används för att stimulera specifika punkter i kroppen...",
            image: require("@/assets/terapi/terapi1.jpg"),
          },
          {
            title: "2. Moxibustion",
            description:
              "Moxibustion är en form av värmeterapi med traditionell kinesisk medicin...",
            image: require("@/assets/terapi/terapi2.jpg"),
          },
          {
            title: "3. Massage",
            description:
              "Massage är en viktig metod inom traditionell kinesisk medicin...",
            image: require("@/assets/terapi/terapi3.jpg"),
          },
          {
            title: "4. Kiropraktik terapi",
            description:
              "Kiropraktisk terapi är en manuell behandling av leder och muskler...",
            image: require("@/assets/terapi/terapi4.jpg"),
          },
          {
            title: "5. Koppning",
            description:
              "Koppning är en speciell behandling enligt traditionell kinesisk medicin...",
            image: require("@/assets/terapi/terapi5.jpg"),
          },
          {
            title: "6. Gua Sha",
            description:
              "Gua Sha är en manuell behandlingsmetod som använder skrapverktyg...",
            image: require("@/assets/terapi/terapi6.jpg"),
          },
          {
            title: "7. Fytoterapi",
            description:
              "Fytoterapi innebär användning av växtbaserade medicinska lösningar...",
            image: require("@/assets/terapi/terapi7.jpg"),
          }
        ],
      };
    },
    methods: {
      // 新增方法，用于打开指定链接
      toLink() {
        window.open('https://yghealthab.simplybook.it/v2/', '_blank');
      },
      toKontakt(){
        this.$router.push('/kontakt');
      }
    }
  };
  </script>
  
  <style scoped lang="scss">
  /* 页面整体样式 */
  .terapi {
    /* max-width: 900px; */
    /* margin: 0 auto; */
    padding: 20px;
    background-color: #fff;
  }
  
  /* 顶部介绍部分 */
  .intro-section {
    text-align: center;
    padding: 20px;
    background: url('@/assets/home/banner.jpg') center/cover no-repeat;
    color: white;
    li{
      list-style: none;
    }
  }
  .book-btn {
    margin-top: 10px;
    background-color: #2e7d32;
    color: white;
  }
  
  /* 治疗内容部分 */
  .treatment-section {
    margin-top: 40px;
  }
  .treatment-item {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
  }
  .treatment-img {
    width: 100%;
    height: 150px;
    border-radius: 5px;
  }
  
  /* 底部按钮 */
  .footer-section {
    /* display: flex; */
    /* justify-content: space-between; */
    text-align: center;
    margin-top: 20px;
  }
  .help-btn {
    background-color: #2e7d32;
    color: white;
  }
  </style>
  
